module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qcirc3-c180bcfcc2550907263e264dc4085cd0.jpg";